import { Box, styled, useMediaQuery } from "@mui/material";
import { primary } from "configs/colors";

export const Container = styled(Box)(({ theme }) => {
  const mdUpMatched = useMediaQuery(theme.breakpoints.up("md"));
  return {
    display: "flex",
    flexDirection: `${mdUpMatched ? "row" : "column"}`,
    minWidth: "100vw",
    minHeight: "100vh",
  };
});

export const Body = styled(Box)<{ collapsed?: boolean }>(
  ({ collapsed, theme }) => {
    const sidebarWidth = collapsed ? 60 : 280;
    const mdUpMatched = useMediaQuery(theme.breakpoints.up("md"));
    return mdUpMatched
      ? {
          flex: 1,
          backgroundColor: primary[700],
          paddingTop: "12px",
          marginLeft: `${sidebarWidth}px`,
          maxWidth: `calc(100vw - ${sidebarWidth}px)`,
          transition: "all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        }
      : {
          height: "100vh",
        };
  }
);

export const Content = styled(Box)(({ theme }) => {
  const mdUpMatched = useMediaQuery(theme.breakpoints.up("md"));
  return {
    backgroundColor: theme.palette.background.default,
    borderRadius: `${mdUpMatched ? "40px 0px 0px 0px" : ""}`,
    padding: "28px 28px 42px 28px",
    height: "100%",
  };
});
